import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { Reveal } from "@/components/Reveal";
import Placeholder from "@/components/Placeholder";

export default function About() {
  const { t } = useLang();
  return (
    <div className="pb-24" data-testid="about-page">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10 pt-14 lg:pt-20">
        {/* header */}
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-20">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="eyebrow mb-4">{t.about.eyebrow}</p>
              <h1 className="font-serif font-light text-[clamp(2.8rem,6vw,5.2rem)] leading-[1.05] text-ink">{t.about.title}</h1>
              <p className="mt-7 max-w-lg text-ink/65 leading-relaxed">{t.about.lead}</p>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.15}>
              <Placeholder variant={1} aspect="aspect-[4/3]" className="rounded-sm" label={t.about.phLabel} />
            </Reveal>
          </div>
        </div>

        {/* story blocks */}
        <div className="space-y-24 lg:space-y-32">
          {[
            { title: t.about.s1Title, body: t.about.s1, variant: 4, flip: false },
            { title: t.about.s2Title, body: t.about.s2, variant: 2, flip: true },
            { title: t.about.s3Title, body: t.about.s3, variant: 0, flip: false },
          ].map((s, i) => (
            <div key={i} className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
              <div className={`lg:col-span-5 ${s.flip ? "lg:order-2 lg:col-start-8" : ""}`}>
                <Reveal>
                  <h2 className="font-serif font-light text-3xl lg:text-4xl text-ink mb-5">{s.title}</h2>
                  <p className="text-ink/70 leading-relaxed max-w-md">{s.body}</p>
                </Reveal>
              </div>
              <div className={`lg:col-span-6 ${s.flip ? "lg:order-1 lg:col-start-1" : "lg:col-start-7"}`}>
                <Reveal delay={0.1}>
                  <Placeholder variant={s.variant} aspect="aspect-[16/10]" className="rounded-sm" label={i === 1 ? t.about.phLabel2 : t.about.phLabel} />
                </Reveal>
              </div>
            </div>
          ))}
        </div>

        {/* quote */}
        <div className="py-24 lg:py-32 mt-8">
          <Reveal className="max-w-3xl mx-auto text-center">
            <p className="font-serif italic font-light text-[clamp(1.5rem,3vw,2.6rem)] leading-snug text-ink">{t.about.quote}</p>
          </Reveal>
        </div>

        {/* values */}
        <Reveal>
          <h2 className="font-serif font-light text-3xl lg:text-4xl text-ink text-center mb-14">{t.about.valuesTitle}</h2>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-10 text-center max-w-4xl mx-auto">
          {[
            { t: t.about.v1t, d: t.about.v1d },
            { t: t.about.v2t, d: t.about.v2d },
            { t: t.about.v3t, d: t.about.v3d },
          ].map((v, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="w-10 h-10 rounded-full bg-rose/15 text-rose-deep flex items-center justify-center mx-auto mb-5 font-serif text-lg">
                {i + 1}
              </div>
              <h3 className="font-serif text-xl text-ink mb-3">{v.t}</h3>
              <p className="text-sm text-ink/60 leading-relaxed">{v.d}</p>
            </Reveal>
          ))}
        </div>

        <div className="text-center mt-20">
          <Link to="/contact" className="btn btn-outline" data-testid="about-contact-cta">{t.nav.contact}</Link>
        </div>
      </div>
    </div>
  );
}
